export const getAdmissionsNotificationLink = (jsonData: any) => {
    const isNewLeadNotification = !!jsonData?.lead?.profileId

    if (isNewLeadNotification) {
        return `/admissions/student/${jsonData.lead.profileId}?tab=admissions`
    }

    if (jsonData?.userId) {
        return `/users/${jsonData.userId}?tab=documents`
    }
}
